import { createOptionalContextFactory } from "../context/createOptionalContextFactory.js";
const DEFAULT_COLOR_SCHEME = "system";
const [ColorSchemeContext, useColorScheme] = createOptionalContextFactory(
  "Interface.ColorScheme",
  DEFAULT_COLOR_SCHEME
);
export {
  ColorSchemeContext,
  DEFAULT_COLOR_SCHEME,
  useColorScheme
};
//# sourceMappingURL=contexts.js.map
